import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider } from './contexts/AuthContext'
import { AuthPage } from './components/Auth/AuthPage'
import { ProtectedLayout } from './components'
import Hub from './pages/Hub'
import CarpeDiem from './pages/CarpeDiem'
import ProjectManagement from './pages/ProjectManagement'
import InspectionReports from './pages/InspectionReports'
import InspectionEditor from './pages/InspectionEditor'
import TeamBrevity from './pages/TeamBrevity'
import PwfTasks from './pages/PwfTasks'
import Dashboard from './pages/Dashboard'
import ProfitabilityPerformance from './pages/ProfitabilityPerformance'
import WorkTypesMatrix from './pages/WorkTypesMatrix'

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="min-h-screen bg-gray-50">
          <Routes>
            <Route path="/auth" element={<AuthPage />} />
            <Route path="/" element={
              <ProtectedLayout>
                <Hub />
              </ProtectedLayout>
            } />
            <Route path="/carpe-diem" element={
              <ProtectedLayout>
                <CarpeDiem />
              </ProtectedLayout>
            } />
            <Route path="/projects" element={
              <ProtectedLayout>
                <ProjectManagement />
              </ProtectedLayout>
            } />
            <Route path="/inspections" element={
              <ProtectedLayout>
                <InspectionReports />
              </ProtectedLayout>
            } />
            <Route path="/inspections/:inspectionId" element={
              <ProtectedLayout>
                <InspectionEditor />
              </ProtectedLayout>
            } />
            <Route path="/team-brevity" element={
              <ProtectedLayout>
                <TeamBrevity />
              </ProtectedLayout>
            } />
            <Route path="/pwf-tasks" element={
              <ProtectedLayout>
                <PwfTasks />
              </ProtectedLayout>
            } />
            <Route path="/dashboard" element={
              <ProtectedLayout>
                <Dashboard />
              </ProtectedLayout>
            } />
            <Route path="/profitability-performance" element={
              <ProtectedLayout>
                <ProfitabilityPerformance />
              </ProtectedLayout>
            } />
            <Route path="/work-types-matrix" element={
              <ProtectedLayout>
                <WorkTypesMatrix />
              </ProtectedLayout>
            } />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  )
}

export default App
